export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-graph-pie-6a1847e9fe8c1be4de017469dbd434d8.svg";